export function testimonialSliderLanding() {
    let $testimonial_slider_landing = $(".testimonial-landing-slider");

    $testimonial_slider_landing.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        slidesToScroll: 1,
        mobileFirst: false,
        dots: true
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/testimonialSliderLanding.js